var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5001 36.8958C36.3728 36.8958 34.3327 36.0508 32.8285 34.5466C31.3243 33.0424 30.4792 31.0022 30.4792 28.875C30.4792 26.7477 31.3243 24.7076 32.8285 23.2034C34.3327 21.6992 36.3728 20.8542 38.5001 20.8542C40.6273 20.8542 42.6675 21.6992 44.1717 23.2034C45.6759 24.7076 46.5209 26.7477 46.5209 28.875C46.5209 29.9283 46.3134 30.9713 45.9104 31.9444C45.5073 32.9176 44.9165 33.8018 44.1717 34.5466C43.4269 35.2914 42.5427 35.8822 41.5695 36.2853C40.5964 36.6884 39.5534 36.8958 38.5001 36.8958ZM38.5001 6.41666C32.5438 6.41666 26.8314 8.7828 22.6196 12.9946C18.4079 17.2063 16.0417 22.9187 16.0417 28.875C16.0417 45.7187 38.5001 70.5833 38.5001 70.5833C38.5001 70.5833 60.9584 45.7187 60.9584 28.875C60.9584 22.9187 58.5923 17.2063 54.3805 12.9946C50.1688 8.7828 44.4564 6.41666 38.5001 6.41666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLocation);
export default __webpack_public_path__ + "static/media/mdi_location.06ed35ba14f2e6b0a392935f4b63390a.svg";
export { ForwardRef as ReactComponent };